/*
 * Potzillas — Showroom
 * - Reveal-on-scroll (.sr-reveal)
 * - Galerie lightbox (otevreni, prev/next, klavesnice, focus trap-lite)
 */
(function () {
  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var targets = document.querySelectorAll('.sr-reveal:not(.is-visible)');
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (t) { t.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    targets.forEach(function (t) { io.observe(t); });
  }

  /* ---------- Lightbox ---------- */
  function initGallery(section) {
    if (!section || section.dataset.galleryReady === '1') return;
    section.dataset.galleryReady = '1';

    var items = Array.prototype.slice.call(section.querySelectorAll('[data-gallery-item]'));
    var box = section.querySelector('[data-lightbox]');
    if (!items.length || !box) return;

    var imgEl = box.querySelector('[data-lightbox-image]');
    var capEl = box.querySelector('[data-lightbox-caption]');
    var btnClose = box.querySelector('[data-lightbox-close]');
    var btnPrev = box.querySelector('[data-lightbox-prev]');
    var btnNext = box.querySelector('[data-lightbox-next]');
    var current = 0;
    var lastFocused = null;

    function render() {
      var item = items[current];
      if (!item) return;
      imgEl.src = item.dataset.full || '';
      imgEl.alt = item.dataset.caption || 'Showroom';
      capEl.textContent = item.dataset.caption || '';
    }

    function open(index) {
      current = index;
      lastFocused = document.activeElement;
      render();
      box.hidden = false;
      document.body.style.overflow = 'hidden';
      btnClose.focus();
    }

    function close() {
      box.hidden = true;
      document.body.style.overflow = '';
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    function move(delta) {
      current = (current + delta + items.length) % items.length;
      render();
    }

    items.forEach(function (item, i) {
      item.addEventListener('click', function () { open(i); });
    });

    btnClose.addEventListener('click', close);
    btnPrev.addEventListener('click', function () { move(-1); });
    btnNext.addEventListener('click', function () { move(1); });

    box.addEventListener('click', function (e) {
      if (e.target === box) close();
    });

    document.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') move(-1);
      else if (e.key === 'ArrowRight') move(1);
    });
  }

  function initAll() {
    initReveal();
    document.querySelectorAll('[data-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initReveal();
    var g = e.target.querySelector('[data-gallery]');
    if (g) initGallery(g);
  });
})();
